import script from "./NotesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesModal.vue?vue&type=script&setup=true&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=679df6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-679df6da"]])

export default __exports__